import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

export const useValidateRecaptcha = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const validateRecaptcha = async () => {
    if (!executeRecaptcha) {
      console.error("reCAPTCHA no está listo");
      return { success: false, message: "reCAPTCHA no está listo" };
    }

    try {
      const recaptchaToken = await executeRecaptcha("submit");

      const response = await fetch("/api/validate-recaptcha", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token: recaptchaToken }),
      });

      const result = await response.json();

      if (!result.success) {
        console.error("Error de reCAPTCHA:", result.message);
      }

      return result;
    } catch (error) {
      console.error("Error validando reCAPTCHA:", error);
      return { success: false, message: "Error interno" };
    }
  };

  return { validateRecaptcha };
};
